export default "__VITE_ASSET__d8cfb82c__"